import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { InputFieldsDirective } from '../input-fields.directive';
import { buildBEMClassNamesByGivenBaseClassAndFlags } from '../../../../utils/class-names';

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./text-field.component.scss']
})
export class TextFieldComponent extends InputFieldsDirective<any> {
  readonly type = input('text');
  readonly placeholder = input('-');
  readonly smart = input(false);
  readonly edited = input(false);
  readonly error = input(false);

  public baseClass = 'text-field';

  public getClassName(): string {
    return buildBEMClassNamesByGivenBaseClassAndFlags(this.baseClass, {
      disabled: this.disabled,
      smart: this.smart(),
      error: this.error(),
      edited: this.edited()
      // touched: this.touched
      // errors: !!this.errors
    });
  }

  // TODO: implement ghost text-field to handle auto resize for variant smart

  // private autoResize(): void {}
}
